<template>
    <section class="translation-key-item d-flex flex-row justify-content-between gap-2">
        <section class="d-flex flex-column">
            <span class="translation-key-item__name">{{ item.name }}</span>
            <span class="translation-key-item__key">{{ item.key }}</span>
        </section>
        <button @click="$store.commit('setEditTranslation', item)" class="translation-key-item__bottom-btn">
                {{ $t('com.global.edit') }}
        </button>
    </section>
</template>
<script charset="utf-8">
export default {
    name: "TranslationKeyItem",
    props: {
        item: {
            type: Object,
            required: true,
            default: () => ({
                id: null,
                key: "",
                name: "",
                description: ""
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.translation-key-item {
    &__key {
        color: #999;
        font-size: 0.8em;
        font-weight: 400;
    }


    &__bottom-btn {
        padding: 5px 10px;
        border: 1px solid #bbc2ce;
        box-sizing: border-box;
        border-radius: 4px;
        background-color: transparent;
        font-weight: 500;
        font-size: 16px;
        height: 30px;
        line-height: 132%;
        color: #00082c;
        transition: all 0.2s ease-in-out;

        &:hover {
            background-color: #e8ebef;
        }
    }
}
</style>